﻿
cb.define(['common/common_VM.Extend.js'], function(common) {
	var ST_st_storetransfer_VM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {
			var detailsModel = viewmodel.get("details");
			if(detailsModel){
				//向后台传递行号
				detailsModel.setState('orderField', 'rowno');
				//单元格编辑之前判断该行商品是否启用批次管理和效期管理,如果未启用，那么不可编辑
				detailsModel.on('rowColChange', function(args) {
					return common.bacthnoAndExpiryDateManage(args, detailsModel);
				});
				//批次参照弹出前事件，看一下商品是否启用批次管理，如果未启用，那么不弹出批次参照
				detailsModel.on('beforeBrowse', function(args) {
					if(args.cellName == 'batchno'){
						var rows = detailsModel.getRows();
						var rowIndex = args.rowIndex;
						var row = rows[rowIndex];
						if(row.isBatchManage == true){

						}else{
							return false;
						}
					}
				});
				
				detailsModel.on('afterCellValueChange', function (data){
					switch (data.cellName) {
						case "productsku_cCode":
						case "productsku_cName":
						case "product_cName" :
						//单元格值改变以后，如果是商品变了，就清空批次号、生效日期、失效日期、批次属性、商品自定义项
						//（sku自定义项是参照带出来的，商品清空就会跟着清空，不许需要在这里处理）
						case "product_cCode" : {
							detailsModel.setCellValue(data.rowIndex, 'batchno', null);
							detailsModel.setCellValue(data.rowIndex, 'producedate',  null);
							detailsModel.setCellValue(data.rowIndex, 'invaliddate',  null);
							for(var i = 1; i <= 30 ; i ++)
							{
								detailsModel.setCellValue(data.rowIndex, 'define'+i, null);
								detailsModel.setCellValue(data.rowIndex, 'prodefine'+i, null);						
							}
							break;
						}
						//单元格值改变以后，如果是批号变了，就清空商品自定义项
						//（批次号、生效日期、失效日期、批次属性、sku自定义项是批次参照带出来的，批次就会跟着清空，不许需要在这里处理）
						case "batchno" : {				
							for(var i = 1; i <= 30 ; i ++)
							{
								detailsModel.setCellValue(data.rowIndex, 'prodefine'+i, null);						
							}
							break;
						}
					}
				});
			}
			

			//联查其他出库单
			viewmodel.on('queryothout', function(args) {
				var originid = viewmodel.get("id").getValue();
				var proxy = cb.rest.DynamicProxy.create({ ensure: { url: args.cSvcUrl, method: args.cHttpMethod } });
				var params = {
					action: 'queryothout',
					billnum: 'st_storetransfer',
					data: JSON.stringify(originid)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					if(result != undefined) {
						cb.utils.alert('操作成功', 'success');
						viewmodel.execute('refresh');
						var params = {
							mode: 'edit',
							readOnly: true,
							id: JSON.parse(result).id
						};
						var data = {
							billtype: 'voucher',
							billno: JSON.parse(result).billno,
							params: params
						};
						cb.loader.runCommandLine('bill', data, viewmodel);
					}

				});
			});
			//联查其他入库单
			viewmodel.on('queryothin', function(args) {
				var originid = viewmodel.get("id").getValue();
				var proxy = cb.rest.DynamicProxy.create({ ensure: { url: args.cSvcUrl, method: args.cHttpMethod } });
				var params = {
					action: 'queryothin',
					billnum: 'st_storetransfer',
					data: JSON.stringify(originid)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					cb.utils.alert('操作成功', 'success');
					viewmodel.execute('refresh');
					var params = {
						mode: 'edit',
						readOnly: true,
						id: JSON.parse(result).id
					};
					var data = {
						billtype: 'voucher',
						billno: JSON.parse(result).billno,
						params: params
					};
					cb.loader.runCommandLine('bill', data, viewmodel);
				});
			});
			
			viewmodel.on('beforeSave', function(args) {
				//保存之前，校验出库仓库和入库仓库不可以相同
				var outWarehouse = viewmodel.get("outWarehouse").getValue();
				var inWarehouse = viewmodel.get("inWarehouse").getValue();
				if(outWarehouse == inWarehouse) {
					cb.utils.alert("出库仓库和入库仓库不可以相同！");
					return false;
				}
				//保存之前，校验数量必须大于零
				var detailsModel = viewmodel.get("details");
				var rows = detailsModel.getRows();
				for(var i = 0; i < rows.length ; i ++){
					if(rows[i].quantity <= 0){
						cb.utils.alert("商品出库数量必须大于零！");
						return false;
					}
				}
			});
			//已审核的单据不允许修改
			viewmodel.on('beforeEdit', function(args) {
				var status = viewmodel.get("status").getValue();
				if(status == 1) {
					cb.utils.alert("已审核的单据不允许修改！");
					return false;
				}
			});
			//已审核的单据不允许删除
			viewmodel.on('beforeDelete', function(args) {
				var status = viewmodel.get("status").getValue();
				if(status == 1) {
					cb.utils.alert("已审核的单据不允许删除！");
					return false;
				}
			});

		},

	}
	try {
		module.exports = ST_st_storetransfer_VM_Extend;
	} catch(error) {

	}
	return ST_st_storetransfer_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storetransfer_VM.Extend.js